// removed by extract-text-webpack-plugin
module.exports = {"mainContainer":"src-layouts----layout-module---mainContainer---Y0VZn","mainContent":"src-layouts----layout-module---mainContent---I7c3g"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/layout.module.less
// module id = 269
// module chunks = 114276838955818